import { render } from "./DokumentViewer.vue?vue&type=template&id=3886628e&scoped=true"
import script from "./DokumentViewer.vue?vue&type=script&lang=js"
export * from "./DokumentViewer.vue?vue&type=script&lang=js"

import "./DokumentViewer.vue?vue&type=style&index=0&id=3886628e&scoped=true&lang=css"
import "./DokumentViewer.vue?vue&type=style&index=1&id=3886628e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3886628e"]])

export default __exports__